import { render, staticRenderFns } from "./LockCard.vue?vue&type=template&id=3fcbf474&"
import script from "./LockCard.vue?vue&type=script&lang=js&"
export * from "./LockCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports